import React from "react";

export const RPGGameStoreColdWeaponIcon = () => {
  return (
    <svg
      width="17"
      height="4"
      viewBox="0 0 17 4"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.6484 0.142322H17L14.7362 2.8764H5.99145L5.74423 2.35206L5.55518 2.10487L5.31765 1.94007L5.09951 1.88015L4.95409 1.85019L4.86199 1.93258L4.50813 2.03745L4.28514 1.85768L4.12033 1.91011L4.03308 4H3.91189L3.45623 1.87266L3.16538 1.58052H0.736812L0.6641 1.65543L0.591389 1.75281L0.547762 1.85019H0.111491L0 1.64794V0.441947L0.218135 0.269663H0.586541L0.736812 0.569288H3.1363L3.66952 0.157303H5.90419L5.97206 0H6.67978L6.91731 0.411985H11.3963L11.6484 0.142322ZM8.75934 2.20974V1.9176H7.35358V2.20974H8.75934ZM9.25863 2.20974H14.3145L14.1594 1.9176H9.25863V2.20974ZM14.5278 1.80524L15.1337 1.10861V0.951311H14.523V1.43071L14.4163 1.58052L14.5278 1.80524Z" />
    </svg>
  );
};

